import { render } from "./TemplatesAreLoading.vue?vue&type=template&id=4448c8de&scoped=true"
import script from "./TemplatesAreLoading.vue?vue&type=script&lang=js"
export * from "./TemplatesAreLoading.vue?vue&type=script&lang=js"

import "./TemplatesAreLoading.vue?vue&type=style&index=0&id=4448c8de&lang=scss&scoped=true"

import exportComponent from "/Users/zvonkobiskup/Code/op3/wp-content/plugins/op-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4448c8de"]])

export default __exports__